var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useMemo } from 'react';
import { EntireBigTitleModal, FloatingButtonGroup, Icon, SignaturePad, SortableWrapper, TextComponent, useEntireLoader } from 'renderer/components';
import styled from 'styled-components';
import Space from 'antd/lib/space';
import Button from 'antd/lib/button';
import { useFieldArray, useForm } from 'react-hook-form';
import { createNanoId, set, useWindowSize } from 'renderer/utils';
import Modal from 'antd/lib/modal';
import { CustomFieldCard } from './CustomFieldCard';
import { ConsentQuery } from 'renderer/queries';
import notification from 'antd/lib/notification';
import { CustomerConsentFormType } from 'renderer/models/CustomerConsentFormModel';
import dayjs from 'dayjs';
var DEFAULT_CUSTOM_FIELDS = [
    {
        key: createNanoId(),
        label: '시술 동의서',
        type: 'input',
        priority: 1,
        isTitle: true,
    },
    {
        key: createNanoId(),
        label: '최근 시술을 받으신 경험이 있나요?',
        type: 'input',
        priority: 2,
        isDraggable: true,
    },
    {
        key: createNanoId(),
        label: '이전에 받으신 시술이 있다면 체크해주세요.',
        type: 'checkbox',
        priority: 3,
        isDraggable: true,
        options: ['선택지1', '선택지2', '선택지3'],
    },
    {
        key: createNanoId(),
        label: '주의 사항',
        type: 'text',
        priority: 4,
        isDraggable: true,
        isText: true,
        text: "1. \uC2DC\uC220 \uBAA9\uC801, \uBC29\uBC95, \uC0AC\uC6A9 \uC81C\uD488\uACFC \uB3C4\uAD6C\uC5D0 \uB300\uD574 \uCDA9\uBD84\uD55C \uC124\uBA85\uC744 \uB4E3\uACE0 \uC774\uD574\uD588\uC2B5\uB2C8\uB2E4.\n2. \uC2DC\uC220 \uC911 \uBD88\uD3B8\uAC10\uC774\uB098 \uD1B5\uC99D\uC774 \uC788\uC744 \uC218 \uC788\uC74C\uC744 \uC778\uC9C0\uD558\uACE0 \uB3D9\uC758\uD569\uB2C8\uB2E4.\n3. \uC2DC\uC220 \uD6C4 \uAC08\uB77C\uC9D0, \uBCC0\uC0C9, \uC57D\uD654, \uC5FC\uC99D \uB4F1 \uBD80\uC791\uC6A9\uC774 \uBC1C\uC0DD\uD560 \uC218 \uC788\uC74C\uC744 \uC548\uB0B4\uBC1B\uC558\uC2B5\uB2C8\uB2E4.\n4. \uC774\uC0C1 \uC99D\uC0C1\uC774 \uC0DD\uAE30\uBA74 \uC989\uC2DC \uC2DC\uC220\uC790\uC5D0\uAC8C \uC54C\uB9AC\uACE0 \uC801\uC808\uD55C \uC870\uCE58\uB97C \uBC1B\uACA0\uC2B5\uB2C8\uB2E4.\n5. \uC2DC\uC220 \uC804 \uAC74\uAC15 \uC0C1\uD0DC(\uC784\uC2E0, \uD53C\uBD80\uC9C8\uD658 \uB4F1)\uB97C \uC815\uD655\uD788 \uC54C\uB824\uC57C \uD558\uBA70, \uBD80\uC801\uD569\uD558\uB2E4\uACE0 \uD310\uB2E8\uB418\uB294 \uACBD\uC6B0 \uC2DC\uC220\uC774 \uC81C\uD55C\uB420 \uC218 \uC788\uC74C\uC744 \uC778\uC9C0\uD569\uB2C8\uB2E4.\n6. \uC2DC\uC220 \uD6C4 3~4\uC2DC\uAC04\uC740 \uBB3C\u2219\uD654\uC7A5\uD488 \uB4F1\uC744 \uD53C\uD558\uACE0, \uACE0\uC2B5\u2219\uACE0\uC5F4 \uD658\uACBD(\uC0AC\uC6B0\uB098 \uB4F1)\uC744 3\uC77C \uC815\uB3C4 \uC0BC\uAC00\uB294 \uB4F1 \uC2DC\uC220\uC790 \uC548\uB0B4\uB97C \uB530\uB974\uACA0\uC2B5\uB2C8\uB2E4.\n7. \uC704 \uB0B4\uC6A9\uC744 \uCDA9\uBD84\uD788 \uC774\uD574\uD558\uACE0, \uC790\uBC1C\uC801\uC73C\uB85C \uC2DC\uC220\uC744 \uC9C4\uD589\uD558\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
    },
];
export var ConsentFormModal = function (_a) {
    var _b;
    var drawer = _a.drawer, onClose = _a.onClose, visible = _a.visible, encodedId = _a.encodedId;
    var isPC = useWindowSize().isPC;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var isSigned = (drawer === null || drawer === void 0 ? void 0 : drawer.signature) && !!(drawer === null || drawer === void 0 ? void 0 : drawer.signedAt);
    var _d = useState(isSigned ? drawer.signature : ''), signature = _d[0], setSignature = _d[1];
    var isUpdated = useMemo(function () {
        return !!(drawer === null || drawer === void 0 ? void 0 : drawer.id);
    }, [drawer === null || drawer === void 0 ? void 0 : drawer.id]);
    var customFields = useMemo(function () {
        if (isUpdated) {
            var title = drawer.title, blocks = drawer.blocks, answers_1 = drawer.answers;
            return __spreadArray([
                {
                    key: createNanoId(),
                    label: title,
                    type: 'input',
                    priority: 1,
                    isTitle: true
                }
            ], blocks.map(function (_a, index) {
                var id = _a.id, blockTitle = _a.title, type = _a.type, content = _a.content;
                return ({
                    key: id,
                    label: blockTitle,
                    type: type,
                    priority: index + 2,
                    isDraggable: true,
                    options: ['checkbox', 'radio'].includes(type) ? content : undefined,
                    isText: type === 'text',
                    text: type === 'text' ? content : undefined,
                    value: isSigned ? answers_1[id] : (type === 'radio' ? content[0] : undefined)
                });
            }), true);
        }
        ;
        return DEFAULT_CUSTOM_FIELDS;
    }, [drawer]);
    var dataKey = 'customFields';
    var defaultValues = set({}, dataKey, customFields);
    var form = useForm({
        defaultValues: defaultValues,
        mode: 'onChange'
    });
    var _e = useFieldArray({
        control: form === null || form === void 0 ? void 0 : form.control,
        name: dataKey
    }), fields = _e.fields, remove = _e.remove, insert = _e.insert;
    var watchFieldArray = form.watch(dataKey);
    var controlledFields = fields.map(function (field, index) {
        return __assign(__assign({}, field), watchFieldArray[index]);
    });
    var isConsent = (drawer === null || drawer === void 0 ? void 0 : drawer.type) === CustomerConsentFormType.CONSENT;
    var _f = useState(isConsent ? undefined : (_b = customFields[0]) === null || _b === void 0 ? void 0 : _b.key), activeKey = _f[0], setActiveKey = _f[1];
    var loader = useEntireLoader();
    var create = ConsentQuery.useCreateConsentTemplateMutation();
    var update = ConsentQuery.useUpdateConsentTemplateMutation();
    var send = ConsentQuery.useSendConsent();
    var externalUpdate = ConsentQuery.useUpdateConsentMutation();
    var isDisableInsertButton = useMemo(function () {
        return form.getValues().customFields.length > 20;
    }, [form.getValues().customFields.length]);
    var isShowFloatingButtonGroup = useMemo(function () {
        if (isConsent) {
            return !isSigned && form.formState.isValid && !!signature;
        }
        return !isUpdated || !!form.formState.isDirty;
    }, [isConsent, isSigned, form.formState.isValid, signature, isUpdated, form.formState.isDirty]);
    var handleClose = function () {
        var action = isConsent ? '서명' : '저장';
        if (isSigned) {
            setOpen(undefined);
            if (onClose) {
                onClose();
            }
        }
        else {
            Modal.confirm({
                cancelText: '나가기',
                okText: '계속',
                title: "\uB3D9\uC758\uC11C ".concat(action, "\uC774 \uC644\uB8CC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."),
                content: "\uACC4\uC18D\uD574\uC11C ".concat(action, "\uC744 \uC644\uB8CC\uD574\uC8FC\uC138\uC694"),
                onOk: function () { },
                onCancel: function () {
                    setOpen(undefined);
                    if (onClose) {
                        onClose();
                    }
                },
                centered: true
            });
        }
    };
    var insertField = function (isText) {
        var key = createNanoId();
        insert(fields.length, {
            label: '제목',
            type: isText ? 'text' : 'input',
            key: key,
            isText: isText,
            isDraggable: true
        });
        setActiveKey(key);
    };
    var resetForm = function () {
        var _a;
        form.reset(defaultValues);
        if (!isConsent) {
            setActiveKey((_a = customFields[0]) === null || _a === void 0 ? void 0 : _a.key);
        }
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customFields, payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loader.show();
                    customFields = form.getValues().customFields;
                    payload = {
                        id: drawer.id,
                        storeId: drawer.storeId,
                        title: customFields[0].label,
                        type: CustomerConsentFormType.TEMPLATE,
                        blocks: customFields.slice(1).map(function (_a) {
                            var type = _a.type, label = _a.label, text = _a.text, options = _a.options;
                            return ({
                                type: type,
                                title: label,
                                content: type === 'text' ? text : (['checkbox', 'radio'].includes(type) ? options : undefined)
                            });
                        })
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!isUpdated) return [3 /*break*/, 3];
                    return [4 /*yield*/, update.mutateAsync(payload)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, create.mutateAsync(payload)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    notification.success({ message: '동의서 저장이 완료되었습니다.' });
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    notification.error({ message: error_1.message });
                    return [3 /*break*/, 7];
                case 7:
                    loader.hide();
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChangeSignature = function (value) {
        setSignature(value);
        if (!!value && !isShowFloatingButtonGroup) {
            form.trigger();
        }
    };
    var handleSign = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customFields, payload, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loader.show();
                    customFields = form.getValues().customFields;
                    payload = {
                        storeId: drawer.storeId,
                        templateId: drawer.templateId,
                        type: drawer.type,
                        title: drawer.title,
                        customerId: drawer.customerId,
                        signatureMethod: drawer.signatureMethod,
                        signature: signature,
                        answers: customFields.slice(1).reduce(function (acc, _a) {
                            var key = _a.key, value = _a.value, type = _a.type;
                            acc[key] = value !== null && value !== void 0 ? value : (type === 'checkbox' ? [] : '');
                            return acc;
                        }, {}),
                        data: {}
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!encodedId) return [3 /*break*/, 3];
                    return [4 /*yield*/, externalUpdate.mutateAsync({
                            id: encodedId,
                            answers: payload.answers,
                            signature: payload.signature
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, send.mutateAsync(payload)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    notification.success({ message: '서명이 완료되었습니다.' });
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    notification.error({ message: error_2.message });
                    return [3 /*break*/, 7];
                case 7:
                    loader.hide();
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (visible !== open) {
            setOpen(visible);
            resetForm();
            if (visible) {
                var expiredAt = drawer === null || drawer === void 0 ? void 0 : drawer.expiredAt;
                if (expiredAt && dayjs().isAfter(expiredAt) && !isSigned) {
                    Modal.confirm({
                        cancelText: '나가기',
                        title: "\uB3D9\uC758\uC11C \uC11C\uBA85 \uC720\uD6A8\uAE30\uAC04\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                        content: (React.createElement(React.Fragment, null,
                            "\uC124\uC815\uD560 \uC218 \uC788\uB294 \uC720\uD6A8\uAE30\uAC04\uC774 \uC9C0\uB0AC\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "\uC0C1\uC810\uC5D0 \uC7AC\uC804\uC1A1\uC744 \uC694\uCCAD\uD574\uC8FC\uC138\uC694.")),
                        onCancel: function () {
                            setOpen(undefined);
                            if (onClose) {
                                onClose();
                            }
                        },
                        centered: true,
                        okButtonProps: { style: { display: 'none' } },
                        maskStyle: { backgroundColor: 'var(--Colors-Neutral-Bg-colorBgMask, rgba(0, 0, 0, 0.45))', backdropFilter: 'blur(30px)' }
                    });
                }
            }
        }
    }, [visible]);
    useEffect(function () {
        if (isSigned) {
            setSignature(drawer === null || drawer === void 0 ? void 0 : drawer.signature);
        }
    }, [isSigned, drawer === null || drawer === void 0 ? void 0 : drawer.signature]);
    return (React.createElement(EntireBigTitleModal, { footer: null, open: !!open, title: isConsent ? drawer.title : '시술동의서', onCancel: handleClose, isFull: true, styles: {
            body: {
                display: 'flex',
                flexDirection: 'column'
            }
        }, className: isShowFloatingButtonGroup ? 'with-floating-button-group' : undefined },
        React.createElement(Body, { style: { padding: isPC ? '0 var(--Components-Modal-Global-paddingContentHorizontalLG, 20px) var(--Components-Modal-Global-marginSM, 12px)' : '0 0 var(--Components-Modal-Global-marginSM, 12px)' } },
            React.createElement(Container, null,
                React.createElement(Space, { style: { padding: isPC ? 20 : '20px 8px', width: isPC ? 560 : '100%' }, direction: "vertical", size: "middle" },
                    React.createElement(Form, null,
                        React.createElement(SortableWrapper, { items: controlledFields, onDragEnd: function (ev) {
                                var _a;
                                var activeIndex = fields.findIndex(function (item) { return item.key === ev.active.id; });
                                var activeItem = watchFieldArray[activeIndex];
                                var overIndex = fields.findIndex(function (item) { return item.key === ev.over.id; });
                                if (!((_a = watchFieldArray[overIndex]) === null || _a === void 0 ? void 0 : _a.isDraggable))
                                    return;
                                remove(activeIndex);
                                insert(overIndex, activeItem);
                                setActiveKey(activeItem.key);
                            }, child: controlledFields.map(function (item, index) {
                                var _a, _b;
                                return (React.createElement(CustomFieldCard, { key: item.key, item: item, form: form, onDelete: index === 0 || isConsent ? undefined : function (id) {
                                        var activeIndex = fields.findIndex(function (item) { return item.key === id; });
                                        remove(activeIndex);
                                    }, name: "".concat(dataKey, ".").concat(index), isActive: item.key === activeKey, onClick: function () {
                                        if (!isConsent) {
                                            setActiveKey(item.key);
                                        }
                                    }, isDraggable: item.isDraggable, isInput: isConsent, customer: encodedId ? { name: (_a = drawer === null || drawer === void 0 ? void 0 : drawer.customer) === null || _a === void 0 ? void 0 : _a.name, phoneToString: (_b = drawer === null || drawer === void 0 ? void 0 : drawer.customer) === null || _b === void 0 ? void 0 : _b.phone } : drawer === null || drawer === void 0 ? void 0 : drawer.customer, readOnly: isSigned }));
                            }) })),
                    !isConsent && (React.createElement("div", null,
                        React.createElement(InsertContainer, null,
                            React.createElement(InsertButton, { text: "\uC9C8\uBB38 \uCD94\uAC00", disabled: isDisableInsertButton, onClick: function () { return insertField(); } }),
                            React.createElement(InsertButton, { text: "\uD14D\uC2A4\uD2B8 \uCD94\uAC00", disabled: isDisableInsertButton, onClick: function () { return insertField(true); } })),
                        isDisableInsertButton && (React.createElement(TextComponent, { style: { marginTop: 2, paddingTop: 2 }, type: "body2", color: "var(--Components-Input-Global-colorError, #FF4D4F)" }, "\uD56D\uBAA9\uC740 20\uAC1C\uB97C \uB118\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.")))),
                    React.createElement(SignatureContainer, null,
                        React.createElement(TextComponent, { style: { padding: '0 8px' }, type: "body2" },
                            "\uC704 \uB0B4\uC6A9\uC744 \uCDA9\uBD84\uD788 \uC774\uD574\uD588\uC73C\uBA70, \uC2DC\uC220\uC744 \uC9C4\uD589\uD558\uB294 \uAC83\uC5D0",
                            React.createElement("br", null),
                            "\uB3D9\uC758\uD558\uC2DC\uBA74, \uC11C\uBA85 \uD574\uC8FC\uC138\uC694."),
                        React.createElement(SignaturePad, { disabled: !isConsent || isSigned, value: signature, onChange: handleChangeSignature }))))),
        !isSigned && (React.createElement(FloatingButtonGroup, { visible: isShowFloatingButtonGroup, confirmButtonProps: {
                onClick: function () { return isConsent ? handleSign() : handleSave(); },
                disabled: isConsent ? undefined : !form.formState.isValid,
                isFull: isConsent && !isPC,
                children: isConsent ? '서명완료' : '저장'
            }, cancelButtonProps: isConsent ? undefined : {
                onClick: function () { return resetForm(); },
                disabled: !form.formState.isDirty
            } }))));
};
var Body = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  overflow-y: hidden;\n"], ["\n  flex: 1;\n  overflow-y: hidden;\n"])));
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-color: var(--Colors-Neutral-Fill-colorFillQuaternary, rgba(0, 0, 0, 0.02));\n  display: flex;\n  justify-content: center;\n  overflow-y: auto;\n"], ["\n  width: 100%;\n  height: 100%;\n  background-color: var(--Colors-Neutral-Fill-colorFillQuaternary, rgba(0, 0, 0, 0.02));\n  display: flex;\n  justify-content: center;\n  overflow-y: auto;\n"])));
var Form = styled.form(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px solid var(--Colors-Neutral-Border-colorSplit, rgba(0, 0, 0, 0.06));\n  border-radius: var(--Border-Radius-borderRadiusLG, 8px);\n  background-color: var(--Colors-Neutral-colorWhite, #FFF);\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n"], ["\n  border: 1px solid var(--Colors-Neutral-Border-colorSplit, rgba(0, 0, 0, 0.06));\n  border-radius: var(--Border-Radius-borderRadiusLG, 8px);\n  background-color: var(--Colors-Neutral-colorWhite, #FFF);\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n"])));
var InsertContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  column-gap: 16px;\n"], ["\n  display: flex;\n  column-gap: 16px;\n"])));
export var InsertButton = function (_a) {
    var style = _a.style, onClick = _a.onClick, disabled = _a.disabled, text = _a.text;
    return (React.createElement(Button, { type: "dashed", style: __assign({ flex: 1, padding: '0 15px', height: 32, display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: 8 }, style), onClick: onClick, disabled: disabled },
        React.createElement(Icon, { name: "plus-circle", size: 16 }),
        " ",
        text));
};
var SignatureContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: auto;\n  width: 320px;\n  & > .signature-pad-wrapper {\n    margin-top: 2px;\n    border: var(--Components-Card-Global-lineWidth, 1px) solid var(--Components-Card-Global-colorBorderSecondary, #F0F0F0);\n    border-radius: var(--Components-Card-Global-borderRadiusLG, 8px);\n    padding: 12px;\n    background-color: var(--Colors-Neutral-Fill-colorFillTertiary, rgba(0, 0, 0, 0.04));\n    justify-content: space-between;\n  }\n"], ["\n  margin-left: auto;\n  width: 320px;\n  & > .signature-pad-wrapper {\n    margin-top: 2px;\n    border: var(--Components-Card-Global-lineWidth, 1px) solid var(--Components-Card-Global-colorBorderSecondary, #F0F0F0);\n    border-radius: var(--Components-Card-Global-borderRadiusLG, 8px);\n    padding: 12px;\n    background-color: var(--Colors-Neutral-Fill-colorFillTertiary, rgba(0, 0, 0, 0.04));\n    justify-content: space-between;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
